import { hookstate } from '@hookstate/core'

const globalImportExportStore = hookstate({
});

export default globalImportExportStore;